import { WEB_EMBED_SCRIPT } from 'env';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const getQueryParams = (search: string): URLSearchParams => {
  return new URLSearchParams(search);
};

export default function EmbedPreview() {
  const location = useLocation();

  const queryParams = getQueryParams(location.search);
  const website: string | null = queryParams.get('website');
  const agentToken: string | null = queryParams.get('agentToken');

  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${WEB_EMBED_SCRIPT}"]`);

    if (!existingScript) {
      const script1 = document.createElement('script');
      script1.src = WEB_EMBED_SCRIPT ?? '';
      script1.id = 'embed-script';
      script1.async = true;

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.addEventListener("load", () => {
          if (window.VoiceBot && !window.VoiceBot.isOpened) {
            window.VoiceBot?.open('${agentToken}');
            window.VoiceBot.isOpened = true;
          }
        });
      `;

      document.head.appendChild(script1);
      document.head.appendChild(script2);

      return () => {
        document.head.removeChild(script1);
        document.head.removeChild(script2);
      };
    }
  }, [agentToken]);

  return (
    <div style={{ height: '100vh', width: '100%', padding: 0, margin: 0 }}>
      {website ? (
        <iframe src={website} title='Website Preview' style={{ width: '100%', height: '100vh', border: 'none' }} />
      ) : (
        <p>No website to preview</p>
      )}
    </div>
  );
}
